import {Injectable, inject} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {Location} from '@angular/common';
import {EventsManager} from 'src/app/services/events.manager';
import {PURCHASE_BASE_PATH} from 'src/app/constants/purchase.constant';

@Injectable()

export class LoadingInterceptor implements HttpInterceptor {
  private _eventsManager = inject(EventsManager);
  private _location: Location = inject(Location);

  private _totalRequests = 0;

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this._location.path().startsWith(PURCHASE_BASE_PATH)) {
      return next.handle(request);
    }
    this._totalRequests++;
    this._eventsManager.setLoadingState(true);
    return next.handle(request).pipe(
      finalize(() => {
        this._totalRequests--;
        if (this._totalRequests == 0) {
          this._eventsManager.setLoadingState(false);
        }
      })
    );
  }
}
